<template>
  <type-ahead
    :src="src"
    :name="name"
    :value="value"
    :classes="'col-md-12 col-sm-12 col-xs-12 col-lg-12'"
    v-validate="validate"
    :placeholder="placeholder"
    :getResponse="getResponse"
    :fetch="fetch"
    :highlighting="highlighting"
    :onHit="onHit"
    :minChars="2"
    @input="clear"
    @keyup.enter.native="search"   
  ></type-ahead>
</template>
<script>
/* eslint-disable no-console */
import TypeAhead from 'vue2-typeahead/src/components/TypeAhead.vue';
export default {
  inject: ['$validator'],
  components: {
    TypeAhead  
  },
  props: {
    src: String,
    name: String,
    value: String,
    validate: Object,
    placeholder: String,
    disabled: Boolean,
  },
  methods: {
    fetch(url) {
      return this.$http
        .get(url)
        .then(response => {
          return response;
        })
        .catch(error => {
          console.log('erro', error);
        });
    },
    highlighting(item, vue) {
      return item.value.toString().replace(vue.query, `<b>${vue.query}</b>`);
    },
    getResponse(response) {
      return response.data;
    },
    onHit(item, vue) {
      if (item.id !== null) {
        vue.query = item.value;
        this.$emit('choice', item);
      }     
    },
    search(payload) {
        this.$emit('search', payload);
    },
    clear(payload) {
      if (payload === '' || payload === null) {
         this.$emit('clear');
      }
    }
  }
};
</script>
<style>
 .typeahead-dropdown-container {
   margin-top: 33px !important;
 }
</style>